class PrimeflowStickyAtc {
  constructor(root) {
    this.root = root;
    this.anchorSelector = root.dataset.anchorSelector;
    this.anchorIsPast = false;
    this.footerIsNearby = false;
    this.handleResize = this.handleResize.bind(this);
    this.observeAnchor();
    this.observeFooter();
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.observeFooter();
  }

  updateVisibility() {
    this.root.classList.toggle('is-visible', this.anchorIsPast && !this.footerIsNearby);
  }

  observeAnchor() {
    if (!this.anchorSelector) return;

    let anchor;
    try {
      anchor = document.querySelector(this.anchorSelector);
    } catch (error) {
      return;
    }

    if (!anchor) return;

    this.anchorObserver?.disconnect();

    this.anchorObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.anchorIsPast = !entry.isIntersecting;
        this.updateVisibility();
      },
      { threshold: 0.05 }
    );

    this.anchorObserver.observe(anchor);
  }

  observeFooter() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    this.footerObserver?.disconnect();

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.footerIsNearby = entry.isIntersecting;
        this.updateVisibility();
      },
      {
        threshold: 0,
        rootMargin: `0px 0px -${Math.ceil(this.root.getBoundingClientRect().height)}px 0px`,
      }
    );

    this.footerObserver.observe(footer);
  }
}

function initializePrimeflowStickyAtc(root = document) {
  root.querySelectorAll('[data-primeflow-sticky-atc]').forEach((element) => {
    if (element.dataset.primeflowStickyInitialized === 'true') return;
    element.dataset.primeflowStickyInitialized = 'true';
    new PrimeflowStickyAtc(element);
  });
}

initializePrimeflowStickyAtc();

document.addEventListener('shopify:section:load', (event) => {
  initializePrimeflowStickyAtc(event.target);
});